"use client";

import { COMING_SOON } from "./_lib/site";
import { Screen } from "./_skins/registry";
import { ComingSoon } from "./_ui/ComingSoon";

/*
 * 🔴 껍데기입니다 — 화면은 활성 스킨의 `home` (`_skins/registry.tsx`).
 *
 * 🔑 **준비 중 화면은 스킨과 무관합니다.** 오픈 전 관문이라 어느 스킨이든 같은 한 장이고,
 *    스킨 화면 청크를 받기 전에 여기서 끝납니다. ⚠️ 루트만 가립니다(직접 주소는 열립니다 —
 *    AGENTS.md §2-3 «아직 없는 것»).
 */
export default function HomePage() {
  if (COMING_SOON) return <ComingSoon />;
  return <Screen name="home" />;
}
